import { useState } from "react";
import ConstraintBlock from "./ConstraintBlock";
import CitizenConstraintRow from "./CitizenConstraintRow";
import StandardButton from "../UI/buttons/StandardButton";
import { Constraint } from "../../types/constraint";
import { useAppDispatch } from "../../store/hooks";
import ConstraintService from "../../service/constraintService";
import { removeConstraintFromClient } from "../../store/constraint";
import constraintStyle from "../../styles/constraint.module.css";
import labels from "../../utils/labels";

const CitizenConstraintContent = ({
  clientId,
  constraints,
}: {
  clientId: number;
  constraints: Constraint[];
}) => {
  const dispatch = useAppDispatch();
  const [isAdding, setIsAdding] = useState(false);

  const handleDelete = async (constraintId: number) => {
    try {
      await ConstraintService.deleteClientConstraint(constraintId, dispatch);
      dispatch(removeConstraintFromClient({ clientId, constraintId }));
    } catch {
      // error notification handled in service
    }
  };

  return (
    <div className="p-[var(--spacing-sm)] flex-col justify-start">
      <ConstraintBlock>
        {constraints.length > 0 && (
          <div
            className={constraintStyle.citizenTableHeaderRow}
            style={{ paddingLeft: "var(--spacing-lg)" }}
          >
            <h4>{labels.consideration}</h4>
            <h4 className={constraintStyle.actionColumn}>{labels.delete}</h4>
          </div>
        )}
        {constraints.map((constraint) => (
          <CitizenConstraintRow
            key={constraint.id}
            constraint={constraint}
            clientId={clientId}
            existingConstraints={constraints}
            onDelete={() => handleDelete(constraint.id)}
          />
        ))}
        {isAdding ? (
          <CitizenConstraintRow
            clientId={clientId}
            existingConstraints={constraints}
            onAddCancel={() => setIsAdding(false)}
          />
        ) : (
          <div style={{ padding: "var(--spacing-sm)" }}>
            <StandardButton
              variant="TERTIARY"
              onClick={() => setIsAdding(true)}
              ariaLabel={labels.addConstraint}
            >
              {labels.addConstraint}
            </StandardButton>
          </div>
        )}
      </ConstraintBlock>
    </div>
  );
};

export default CitizenConstraintContent;
